/** @format */

import { notificationConstants } from './notifications';
import { reducerDebug } from '../../core/debug';

const defaultState = {
    notifications: [],
};

export default function notificationReducers(state = defaultState, action) {
    switch (action.type) {
        case notificationConstants.ENQUEUE_SNACKBAR:
            return {
                ...state,
                notifications: [
                    ...state.notifications,
                    {
                        key: action.key,
                        ...action.notification,
                    },
                ],
            };

        case notificationConstants.CLOSE_SNACKBAR:
            return {
                ...state,
                notifications: state.notifications.map((notification) =>
                    action.dismissAll || notification.key === action.key ? { ...notification, dismissed: true } : { ...notification }
                ),
            };

        case notificationConstants.REMOVE_SNACKBAR:
            return {
                ...state,
                notifications: state.notifications.filter((notification) => notification.key !== action.key),
            };

        default:
            return { ...state };
    }
}

export function notify(state = {}, action) {
    reducerDebug('Notification message: ' + action.type);
    switch (action.type) {
        case notificationConstants.SUCCESS:
        case notificationConstants.WARNING:
        case notificationConstants.INFO:
            return {
                type: action.type,
                message: action.message,
                error: null,
                variant: null,
            };
        case notificationConstants.ERROR:
        case notificationConstants.SUBMIT_ERROR:
            return {
                type: action.type,
                message: action.message,
                error: action.error,
                variant: null,
            };
        case notificationConstants.NOTFOUND:
            return {
                type: action.type,
                error: action.error,
                variant: null,
                message: null,
            };
        case notificationConstants.REQUEST_STARTED:
            return {
                type: action.type,
                message: 'pokaz pyrkacza',
                error: null,
                variant: null,
            };
        case notificationConstants.REQUEST_FINISHED:
            return {
                type: action.type,
                message: 'schowaj pyrkacza',
                error: null,
                variant: null,
            };
        case notificationConstants.CUSTOM_NOTIFY:
            return {
                type: action.type,
                message: action.message,
                variant: action.variant,
                error: null,
            };
        case notificationConstants.CLEAR_NOTIFY:
        default:
            return {
                ...state,
                type: null,
                error: null,
                message: null,
                variant: null,
            };
    }
}
